var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23021 4.86606L4.38047 6.01632L7.06441 3.33238M8.21467 6.01632C7.83125 6.39974 8.69395 7.45415 8.21467 7.93342C7.7354 8.4127 6.68099 7.55 6.29757 7.93342C5.91415 8.31684 5.72244 9.08369 5.14731 9.08369C4.57218 9.08369 4.38047 8.31684 3.99705 7.93342C3.61363 7.55 2.55922 8.4127 2.07995 7.93342C1.60067 7.45415 2.46337 6.39974 2.07995 6.01632C1.69653 5.6329 0.929688 5.44119 0.929688 4.86606C0.929688 4.29093 1.69653 4.09922 2.07995 3.7158C2.46337 3.33238 1.60067 2.27797 2.07995 1.7987C2.55922 1.31942 3.61363 2.18212 3.99705 1.7987C4.38047 1.41528 4.57218 0.648438 5.14731 0.648438C5.72244 0.648438 5.91415 1.41528 6.29757 1.7987C6.68099 2.18212 7.7354 1.31942 8.21467 1.7987C8.69395 2.27797 7.83125 3.33238 8.21467 3.7158C8.59809 4.09922 9.36494 4.29093 9.36494 4.86606C9.36494 5.44119 8.59809 5.6329 8.21467 6.01632Z",
    stroke: "#68767C",
    strokeWidth: 0.93725
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.aa294e333a34a53a84cad3748e0bd0f2.svg";
export { ForwardRef as ReactComponent };